import { getTimelines, getTimeline, searchTimelines, exploreTimelines, getLyrics } from 'api/timeline';
import { useMutation } from 'react-query';

function useTimelines() {
  return useMutation(getTimelines, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
  });
}

function useTimeline() {
  return useMutation(getTimeline, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
  });
}

function useSearchTimelines() {
  return useMutation(searchTimelines, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
  });
}

function useExploreTimelines() {
  return useMutation(exploreTimelines, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
  });
}



function useGetTimelineLyrics() {
  return useMutation(getLyrics, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
  });
}


export {useTimelines, useTimeline, useSearchTimelines, useExploreTimelines, useGetTimelineLyrics };
